import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from "pinia-plugin-persistedstate"
import App from '@/components/App.vue'
import Login from '@/components/Login.vue'
import PasswordResetRequest from '@/components/PasswordResetRequest.vue'
import PasswordResetEdit from '@/components/PasswordResetEdit.vue'
import Profile from '@/components/Profile.vue'
import i18n from '@/locales/i18n'; // adjust path as needed
import '@/utils/axios' // Initialize axios interceptor for locale headers
import "@/index.css";
import "@/env.css";
import { useColumnStore } from '@/stores/columnStore'

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);
app.use(pinia)
app.use(i18n)

const columnStore = useColumnStore()
columnStore.cleanupStaleKeys()

if (document.querySelector('#app')) {
  app.mount('#app')
}


if (document.querySelector('#login')) {
  const login = createApp(Login)
  login.use(pinia);
  login.use(i18n)
  login.mount('#login')
}

if (document.querySelector('#password-reset-request')) {
  const passwordResetRequest = createApp(PasswordResetRequest)
  passwordResetRequest.use(pinia)
  passwordResetRequest.use(i18n)
  passwordResetRequest.mount('#password-reset-request')
}

const passwordResetEditEl = document.querySelector('#password-reset-edit')
if (passwordResetEditEl) {
  const passwordResetEdit = createApp(PasswordResetEdit, {
    token: passwordResetEditEl.dataset.token || '',
  })
  passwordResetEdit.use(pinia)
  passwordResetEdit.use(i18n)
  passwordResetEdit.mount(passwordResetEditEl)
}

const profileEl = document.querySelector('#profile')
if (profileEl) {
  const profile = createApp(Profile, {
    initialUser: JSON.parse(profileEl.dataset.user || '{}'),
    impersonating: profileEl.dataset.impersonating === 'true',
  })
  profile.use(pinia)
  profile.use(i18n)
  profile.mount(profileEl)
}
